<script lang="ts">
  import { componentLibrary } from '../../../store/componentLibrary';

  export let children: any;
  export let passThroughProps: any = {};
</script>

{#if Array.isArray(children)}
  {#each children as child}
    {#if $componentLibrary[child.componentName]}
      <svelte:component this={$componentLibrary[child.componentName]} {...child.props} {...passThroughProps} />
    {/if}
  {/each}
{:else if $componentLibrary[children.componentName]}
  <svelte:component this={$componentLibrary[children.componentName]} {...children.props} {...passThroughProps} />
{/if}
